import { render } from "./genrePage.vue?vue&type=template&id=7c1ae272&scoped=true"
import script from "./genrePage.vue?vue&type=script&lang=js"
export * from "./genrePage.vue?vue&type=script&lang=js"

import "./genrePage.vue?vue&type=style&index=0&id=7c1ae272&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c1ae272"]])

export default __exports__